"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    firmImports: {
        path: "/settings/data-imports/firms",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlybUltcG9ydHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL2Zpcm1JbXBvcnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsV0FBVyxFQUFFO1FBQ1gsSUFBSSxFQUFFLDhCQUE4QjtLQUNyQztDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgZmlybUltcG9ydHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9kYXRhLWltcG9ydHMvZmlybXNcIixcbiAgfSxcbn0pO1xuIl19